import { useTranslation } from 'react-i18next';

import { useUser } from '../../../../../../../../hooks/useUser';
import { UserRole } from '../../../../../../../../types/user';
import { MAX_NUMBER_OF_YEARS_IN_THE_FUTURE } from '../../../../../../../../components/registering/utils/validation';

export const useYearValidation = () => {
  const { t } = useTranslation();
  const { user } = useUser();

  const allowedFutureYears = user?.rolle === UserRole.PROFESJONELL ? MAX_NUMBER_OF_YEARS_IN_THE_FUTURE : 0;
  const currentYear = new Date().getFullYear();

  const maxYearAllowed = currentYear + allowedFutureYears;
  const validateYearAndBuildYear = (value: number | undefined, byggAr?: number) => {
    if (!value) {
      return t('form.oppvarming.common.installasjonsAr.error.missing');
    }

    if (value > currentYear + allowedFutureYears) {
      return t('form.oppvarming.common.installasjonsAr.error.invalid', { year: maxYearAllowed });
    }

    if (byggAr && value < byggAr) {
      return t('form.oppvarming.common.installasjonsAr.error.tooEarly', { byggAr });
    }

    return true;
  };

  const validateYear = (value: number | undefined) => {
    return validateYearAndBuildYear(value);
  }

  const yearPattern = {
    value: /^(19|20)\d{2}$/,
    message: t('form.oppvarming.common.installasjonsAr.error.invalid', { year: maxYearAllowed })
  };

  return { validateYear, validateYearAndBuildYear, yearPattern };
};
